var _defs, _style, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 748.20001 172.10001",
    width: 748.20001,
    height: 172.10001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs25"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#FFFFFF;}\r\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", {
    id: "switch20",
    transform: "translate(-125.9,-399.9)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "357.5,426.4 412.2,426.4 412.2,503.6 446,503.6 446,399.9 323.8,399.9 323.8,503.6 357.5,503.6 ",
    id: "polygon4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 571.2,411.3 c -9.5,-7.6 -21.7,-11.4 -36.2,-11.4 h -71.2 v 103.7 h 33.3 V 482.1 H 535 c 14.5,0 26.6,-3.7 36.2,-11 9.8,-7.5 14.7,-17.5 14.7,-29.8 0,-12.2 -4.9,-22.3 -14.7,-30 z m -18.6,30.1 c 0,4.4 -1.5,7.6 -4.7,10 -3.4,2.5 -8.1,3.8 -14,3.8 H 497.1 V 427 H 534 c 5.8,0 10.5,1.4 13.8,4.1 3.2,2.4 4.8,5.8 4.8,10.3 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "601.4,399.9 601.4,503.6 631.9,503.6 694.5,442.1 694.5,503.6 727.5,503.6 727.5,399.9 697.2,399.9 634.5,461.8 634.5,399.9 ",
    id: "polygon8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "779.8,436.7 779.8,399.9 745.1,399.9 745.1,503.5 779.8,503.5 779.8,463.3 839.4,463.3 839.4,503.5 874.1,503.5 874.1,399.9 839.4,399.9 839.4,436.7 ",
    id: "polygon10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "253.2,436.5 271,428.5 262.9,446.3 236.7,503.6 299.9,503.6 299.9,399.9 196.2,399.9 196.2,462.1 ",
    id: "polygon12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "196.2,471.9 125.9,503.5 196.2,503.5 196.2,572 227.5,503.5 253.8,446 ",
    id: "polygon14"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02ad011d31d2aa779acbcad9b02c813a.svg";
export { ForwardRef as ReactComponent };